import request from '@/utils/request'

export interface ReferralStats {
  totalReferrals: number
  pendingReferrals: number
  completedReferrals: number
  rewardedReferrals: number
  totalBonusDaysGranted: number
  periodStats?: {
    newReferralsThisWeek: number
    newReferralsThisMonth: number
    conversionRate: number
  }
}

export interface Referral {
  id: number
  referrerUserId: string
  referredUserId: string
  referralCode: string
  status: 'pending' | 'completed' | 'rewarded' | 'expired' | 'cancelled'
  qualifyingPurchaseId?: number
  referrerBonusEntitlementId?: number
  referredBonusEntitlementId?: number
  metadataJson?: any
  completedAt?: Date
  rewardedAt?: Date
  expiresAt?: Date
  createdAt: Date
  updatedAt: Date
  // Joined data
  referrerEmail?: string
  referredEmail?: string
}

export interface UserReferralCode {
  id: number
  userId: string
  referralCode: string
  isActive: boolean
  totalReferrals: number
  successfulReferrals: number
  totalBonusEarned?: number
  metadataJson?: any
  createdAt: Date
  updatedAt: Date
  // Joined data
  userEmail?: string
}

// Admin: Get all referrals with pagination
export const getAllReferrals = (params?: {
  page?: number
  limit?: number
  status?: string
  startDate?: string
  endDate?: string
}) =>
  request({
    url: '/admin/referrals',
    method: 'get',
    params
  })

// Admin: Get referral statistics
export const getReferralStatistics = () =>
  request({
    url: '/admin/referrals/statistics',
    method: 'get'
  })

// Admin: Complete a referral manually
export const completeReferral = (referredUserId: string) =>
  request({
    url: `/admin/referrals/${referredUserId}/complete`,
    method: 'post'
  })

// Validate a referral code
export const validateReferralCode = (code: string) =>
  request({
    url: `/referral/validate/${code}`,
    method: 'get'
  })
